import ApiServer from "../ApiServer.js";
import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";

export {init}
Html.registerWidget('widget/comments',{init:init})

ApiServer["custom.wallcomment"] = function(form,success,error){
  form = $(form)
  var 
    metaId = form.metaId(),
    text = form.find('textarea').val();
  
  if(text===null || text===undefined){
    ApiServer.webjslog("Bad form for commenting, no textarea? "+form.html().replace(/<!--.*-->/g,''))
  }
  //if direct call of tpl it cause circular dependancy which make the build blow up
  import('../feed/commentsandco.mustache').then(function(TPL_commentsandco){
    ApiServer.metacomment.noPg()(metaId,text);
    ApiServer.metaget(metaId,function(metaItem){
      var 
        lastcomment = metaItem.comments[metaItem.comments.length-1];
      lastcomment.justUpdated = true;
      
      $('[data-fw-meta-id="'+metaId+'"] .fw-comments-container').each(function(idx,node){
        Html.replaceWith($(node),TPL_commentsandco,metaItem);
      })
      
    });
    amplify.publish('CommentChanged')
  });
}

function init(node){
  let obj = node.find("form input");
  obj.on('focus',function(){
    import("../form/comment.mustache").then(function(TPL){
      obj.hide();
      Html.setHtmlAtEnd(obj.parent(),TPL,{});
      obj.parent().on('reset',function(){
        obj.show();
        obj.next().remove();
      });
    });
  });
}

